import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../../components/Layout/Header/Header";
import Footer from "../../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../../components/Common/ScrollTop";
import OffWrap from "../../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../../components/Common/Breadcumb";
import SearchModal from "../../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../../utils/fetchData";
import Accreditation from "../../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../../utils/getDomainData";

const OTPRI_PharmaceuticalChemistry = () => {
    const [data, setData] = useState([]);
    let location = useLocation();
    const currentDomain = location.pathname.split("/")[1];
    const { fontSize } = useFontSize();

    useEffect(() => {
        fetchData(getAPIPath(currentDomain)?.pharmaceuticalChemistry, setData);
    }, [currentDomain]);

    const pharmaceuticalChemistryData = data?.data?.attributes;

    return (
        <React.Fragment>
            <Helmet>
                <title>Pharmaceutical Chemistry | Oil Technological & Pharmaceutical Research Institute | JNTU Anantapur</title>
                <meta
                    name="description"
                    content="Pharmaceutical Chemistry Department at JNTUA Oil Technological and Pharmaceutical Research Institute (OT&PRI) - Learn about our department, faculty, and research activities."
                />
                <meta
                    name="keywords"
                    content="OTPRI Pharmaceutical Chemistry, Oil Technological, Pharmaceutical Research Institute, JNTUA, Department Information"
                ></meta>
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="home"
                TopBar="enable"
                TopBarClass="topbar-area dark-primary-bg hidden-lg"
            />
            <style>
                {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .department-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                    .department-section {
                        background: #fff;
                        padding: 50px 0;
                    }
                    .section-heading {
                        color: #007bff;
                        font-weight: bold;
                        margin-bottom: 30px;
                        border-bottom: 3px solid #007bff;
                        padding-bottom: 10px;
                        display: inline-block;
                    }
                    .links-section {
                        padding: 40px 0;
                        background: #f8f9fa;
                    }
                    .link-card {
                        background: #fff;
                        border-radius: 8px;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                        padding: 15px 20px;
                        height: auto;
                        border-left: 4px solid #007bff;
                        transition: transform 0.3s ease, box-shadow 0.3s ease;
                        text-align: center;
                        cursor: pointer;
                        text-decoration: none;
                        display: block;
                        color: inherit;
                    }
                    .link-card:hover {
                        transform: translateY(-3px);
                        box-shadow: 0 5px 20px rgba(0,0,0,0.15);
                        text-decoration: none;
                        color: inherit;
                    }
                    .link-card.disabled {
                        cursor: not-allowed;
                        opacity: 0.7;
                        background: #f8f9fa;
                    }
                    .link-card.disabled:hover {
                        transform: none;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                    }
                    .link-title {
                        color: #333;
                        font-weight: bold;
                        margin-bottom: 0;
                        font-size: 1.1rem;
                    }
                    .news-section {
                        padding: 40px 0;
                    }
                    .news-card {
                        background: #fff;
                        border-radius: 8px;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                        padding: 25px;
                        margin-bottom: 20px;
                        border-left: 4px solid #28a745;
                        transition: transform 0.3s ease, box-shadow 0.3s ease;
                    }
                    .news-card:hover {
                        transform: translateX(5px);
                        box-shadow: 0 5px 15px rgba(0,0,0,0.15);
                    }
                    .news-title {
                        color: #333;
                        font-weight: bold;
                        margin-bottom: 10px;
                        font-size: 1.1rem;
                    }
                    .news-date {
                        color: #666;
                        font-size: 0.9rem;
                        margin-bottom: 15px;
                    }
                    .department-info {
                        background: #f8f9fa;
                        padding: 30px;
                        border-radius: 10px;
                        margin-bottom: 30px;
                        border-left: 5px solid #007bff;
                    }
                    .department-meta {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 20px;
                        flex-wrap: wrap;
                        gap: 15px;
                    }
                    .meta-item {
                        background: #fff;
                        padding: 10px 20px;
                        border-radius: 25px;
                        box-shadow: 0 2px 5px rgba(0,0,0,0.1);
                        font-size: 0.9rem;
                    }
                    .meta-label {
                        font-weight: bold;
                        color: #007bff;
                        margin-right: 5px;
                    }
                    .no-content {
                        text-align: center;
                        color: #666;
                        font-style: italic;
                        padding: 40px 20px;
                        background: #f8f9fa;
                        border-radius: 8px;
                        margin: 20px 0;
                    }
                `}
            </style>
            <div className="pageTopOffset">
                {/* breadcrumb-area-start */}
                <SiteBreadcrumb
                    pageTitle="Pharmaceutical Chemistry"
                    pageName="Pharmaceutical Chemistry"
                    breadcrumbsClass="breadcrumb-bg"
                />
                {/* breadcrumb-area-start */}
                {getMenu(currentDomain)}
                
                <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
                    <div className="container">
                        <div className="row">
                            <div className="col pl-20 md-pl-14">
                                <div className="row">
                                    <div className="rs-inner-blog col-lg-12">
                                        {/* Page Title */}
                                        <h1 className="department-title text-center mb-5">
                                            Pharmaceutical Chemistry Department
                                        </h1>

                                        {/* Department Information */}
                                        {pharmaceuticalChemistryData && (
                                            <div className="department-info">
                                                <div className="department-meta">
                                                    {pharmaceuticalChemistryData.date && (
                                                        <div className="meta-item">
                                                            <span className="meta-label">Date:</span>
                                                            {new Date(pharmaceuticalChemistryData.date).toLocaleDateString()}
                                                        </div>
                                                    )}
                                                    {pharmaceuticalChemistryData.author && (
                                                        <div className="meta-item">
                                                            <span className="meta-label">Author:</span>
                                                            {pharmaceuticalChemistryData.author}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {/* Sections */}
                                        {pharmaceuticalChemistryData?.section && pharmaceuticalChemistryData.section.length > 0 && (
                                            <div className="department-sections">
                                                {pharmaceuticalChemistryData.section.map((section, sectionIndex) => (
                                                    <div key={section.id || sectionIndex} className="department-section">
                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                {/* Links Section */}
                                                                {section.link && section.link.length > 0 && (
                                                                    <div className="links-section">
                                                                        <h3 className="mb-4">Department Resources</h3>
                                                                        <div className="row">
                                                                            {section.link.map((link, linkIndex) => (
                                                                                <div key={link.id || linkIndex} className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                                                                    {link?.content?.data?.attributes?.url ? (
                                                                                        <a 
                                                                                            href={`${imageBaseURL}${link.content.data.attributes.url}`} 
                                                                                            target="_blank" 
                                                                                            rel="noopener noreferrer" 
                                                                                            className="link-card"
                                                                                        >
                                                                                            <h5 className="link-title">{link.label}</h5>
                                                                                        </a>
                                                                                    ) : (
                                                                                        <div className="link-card disabled">
                                                                                            <h5 className="link-title">{link.label}</h5>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* News Section */}
                                                                {/* {section.news && section.news.length > 0 ? (
                                                                    <div className="news-section">
                                                                        <h3 className="section-heading">Related Posts</h3>
                                                                        <div className="row">
                                                                            {section.news.map((newsItem, newsIndex) => (
                                                                                <div key={newsItem.id || newsIndex} className="col-lg-6 col-md-12 mb-3">
                                                                                    <div className="news-card">
                                                                                        <h5 className="news-title">{newsItem.title}</h5>
                                                                                        {newsItem.date && (
                                                                                            <div className="news-date">
                                                                                                {new Date(newsItem.date).toLocaleDateString()}
                                                                                            </div>
                                                                                        )}
                                                                                        {newsItem.content && (
                                                                                            <p>{newsItem.content}</p>
                                                                                        )}
                                                                                        {newsItem.url && (
                                                                                            <a 
                                                                                                href={newsItem.url} 
                                                                                                target="_blank" 
                                                                                                rel="noopener noreferrer"
                                                                                                className="link-button"
                                                                                            >
                                                                                                Read More
                                                                                            </a>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="news-section">
                                                                        <h3 className="section-heading">Latest News & Updates</h3>
                                                                        <div className="no-content">
                                                                            No news updates available at the moment.
                                                                        </div>
                                                                    </div>
                                                                )} */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {/* Fallback if no data */}
                                        {(!pharmaceuticalChemistryData?.section || pharmaceuticalChemistryData.section.length === 0) && (
                                            <div className="no-content">
                                                <h3>Pharmaceutical Chemistry Department</h3>
                                                <p>Department information will be updated soon. Please check back later.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Accreditation />

            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />

            {/* scrolltop-start */}
            <ScrollToTop scrollClassName="scrollup orange-color" />
            {/* scrolltop-end */}

            <SearchModal />
        </React.Fragment>
    );
};

export default OTPRI_PharmaceuticalChemistry;